<template>
  <button type="button" class="customer-upgrade-tile" :aria-label="pack.packageName + ' dazu buchen'" @click="$emit('select', pack)">
    <span class="customer-upgrade-tile__icon"><v-icon size="19" aria-hidden="true">{{ icon }}</v-icon></span>
    <span class="customer-upgrade-tile__copy">
      <strong>{{ pack.packageName }}</strong>
      <small v-if="pack.externalPackage">{{ studios ? 'In ' + studios : 'In anderen Studios' }}</small>
      <span>Dazu buchen <v-icon size="13" aria-hidden="true">mdi-plus</v-icon></span>
    </span>
  </button>
</template>

<script>
import { customerHubPackageIcon } from "@/services/customerHubUpgrades"
export default {
  name: "CustomerHubUpgradeTile",
  props: { pack: { type: Object, required: true } },
  computed: {
    icon() { return customerHubPackageIcon(this.pack.packageName) },
    studios() { return (Array.isArray(this.pack.availableInStudios) ? this.pack.availableInStudios : []).filter(name => typeof name === "string").join(", ") },
  },
}
</script>

<style scoped>
.customer-upgrade-tile { display: flex; align-items: center; gap: 10px; width: 100%; min-width: 0; min-height: 78px; padding: 13px 11px; border: 1px dashed #ffffff24; border-radius: 14px; background: #ffffff02; text-align: left; }
.customer-upgrade-tile:hover { background: #ffffff07; border-color: #ffffff40; }
.customer-upgrade-tile:focus-visible { outline: 2px solid var(--v-primary-base, #00963f); outline-offset: 2px; }
.customer-upgrade-tile__icon { display: grid; place-items: center; flex: 0 0 34px; height: 34px; border-radius: 10px; background: #ffffff04; }
.customer-upgrade-tile__icon .v-icon { color: #999999; }
.customer-upgrade-tile__copy { flex: 1; min-width: 0; }
.customer-upgrade-tile strong { display: block; color: #b3b3b3; font-size: 12px; line-height: 1.4; font-weight: 500; overflow-wrap: anywhere; }
.customer-upgrade-tile small { display: block; color: #a6a6a6; font-size: 10px; line-height: 1.5; margin-top: 4px; }
.customer-upgrade-tile__copy > span { display: flex; align-items: center; gap: 4px; color: #d0d0d0; font-size: 10px; margin-top: 5px; }
.customer-upgrade-tile__copy > span .v-icon { color: var(--v-primary-base, #00963f); }
@media (max-width: 420px) { .customer-upgrade-tile { align-items: flex-start; flex-wrap: wrap; gap: 8px; padding: 12px 10px; }.customer-upgrade-tile__icon { flex-basis: 28px; height: 28px; border-radius: 8px; }.customer-upgrade-tile__copy { flex-basis: calc(100% - 40px); } }
</style>
